import script from "./AchievementTypeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementTypeSection.vue?vue&type=script&setup=true&lang=js"

import "./AchievementTypeSection.vue?vue&type=style&index=0&id=29b9d124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29b9d124"]])

export default __exports__